<template>
  <section>
    <base-card>
      <h2>Page Not Found</h2>
      <p>
        This page could not be found.
      </p>
    </base-card>
  </section>
</template>